/**
 * service-hero-carousel.js
 * Shared bootstrap for the six pages/services/{prefix}/index.html hero
 * carousels (academic/career/design/digital/tutoring/automation). Wraps initCarousel()
 * with the id/selector convention every page already follows
 * (#<prefix>-track, #<prefix>-dots .<prefix>-dot) and the fixedHeight
 * behavior all six pages need, so it's defined once instead of copy-pasted
 * per page.
 *
 * Usage:
 *   import { initServiceHeroCarousel } from '../../../js/utils/service-hero-carousel.js';
 *   const { step, goTo } = initServiceHeroCarousel('ac', { interval: 5500 });
 */

import { initCarousel } from './carousel-animate.js';

export function initServiceHeroCarousel(prefix, extra = {}) {
  return initCarousel({
    track: document.getElementById(`${prefix}-track`),
    dots: document.querySelectorAll(`#${prefix}-dots .${prefix}-dot`),
    interval: 5500,
    fixedHeight: true,
    ...extra,
  });
}
